/* eslint-disable react/jsx-pascal-case */
import { Route, HashRouter as Router, Routes } from "react-router-dom";
import About from "./1.APPWEB/About";
import Event_About from "./1.APPWEB/Event_About";
import Home from "./1.APPWEB/Home";
import Info from "./1.APPWEB/Info";
import Platform from "./1.APPWEB/Platform";
import Platform_Info from "./1.APPWEB/Platform_Info";
import Process_Home from "./1.APPWEB/Process_Home";
import About_FMS from "./2.FMS/About_FMS";
import Home_FMS from "./2.FMS/Home_FMS";
import Info_FMS from "./2.FMS/Info_FMS";
import Platform_FMS from "./2.FMS/Platform_FMS";
import Process_FMS from "./2.FMS/Process_FMS";
import About_Live from "./3.Live_Commerce/About_Live";
import Home_Live from "./3.Live_Commerce/Home_Live";
import Info_Live from "./3.Live_Commerce/Info_Live";
import Platform_Live from "./3.Live_Commerce/Platform_Live";
import Process_Live from "./3.Live_Commerce/Process_Live";
import Rosepay_use from "./Rosepay_use";
import Home_SSMS from "./4.SSMS/Home_SSMS";
import About_SSMS from "./4.SSMS/About_SSMS";
import Platform_SSMS from "./4.SSMS/Platform_SSMS";
import Info_SSMS from "./4.SSMS/Info_SSMS";
import Process_SSMS from "./4.SSMS/Process_SSMS";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/Info" element={<Info />} />
        <Route path="/Platform" element={<Platform />} />
        <Route path="/Platform_Info" element={<Platform_Info />} />
        <Route path="/Process_Home" element={<Process_Home />} />
        <Route path="/Event_About" element={<Event_About />} />
        <Route path="/FMS/" element={<Home_FMS />} />
        <Route path="/FMS/about" element={<About_FMS />} />
        <Route path="/FMS/Platform" element={<Platform_FMS />} />
        <Route path="/FMS/Info" element={<Info_FMS />} />
        <Route path="/FMS/Process_FMS" element={<Process_FMS />} />
        <Route path="/rosepay_use/:seq" element={<Rosepay_use />} />
        <Route path="/Live_Commerce/" element={<Home_Live />} />
        <Route path="/Live_Commerce/Info" element={<Info_Live />} />
        <Route path="/Live_Commerce/Process" element={<Process_Live />} />
        <Route path="/Live_Commerce/Platform" element={<Platform_Live />} />
        <Route path="/Live_Commerce/About" element={<About_Live />} />
        <Route path="/SSMS/" element={<Home_SSMS />} />
        <Route path="/SSMS/about" element={<About_SSMS />} />
        <Route path="/SSMS/Platform" element={<Platform_SSMS />} />
        <Route path="/SSMS/Info" element={<Info_SSMS />} />
        <Route path="/SSMS/Process_SSMS" element={<Process_SSMS />} />
        {/* 여기에 추가 라우트를 정의할 수 있습니다. */}
      </Routes>
    </Router>
  );
}

export default App;
